import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link} from '@customink/pigment-react';

import {swapProductWarning} from '~/actions/AnalyticsActions';
import {useDispatch} from 'react-redux';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function SwapProductsWarning({dismiss, ...props}) {
  const dispatch = useDispatch();

  const continueHandler = () => {
    dispatch(swapProductWarning('continue'));
    dismiss();
  };
  return (
    <Notification {...props} title="Heads up!">
      <p className="ndx-cta1">
        Swapping this product will remove all other colors/styles in your list.
      </p>
      <Button
        size="large"
        variant="secondary"
        className="notification-cta"
        href="#/productCatalog"
        onClick={continueHandler}>
        Continue
      </Button>
      <p className="ndx-cta1">
        <br />
        or{' '}
        <Link href="#/help" onClick={dismiss}>
          contact us
        </Link>{' '}
        for more options.
      </p>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

SwapProductsWarning.propTypes = propTypes;

SwapProductsWarning.displayName = 'SwapProductsWarning';
